import { ccFeesHasValues } from './settings-predicates';
export const renderedSettingsFields = (param)=>{
    let { fields, paymentSettings, agreementSettings } = param;
    const rendered = [];
    if (fields.netTerms != null && (paymentSettings === null || paymentSettings === void 0 ? void 0 : paymentSettings.netTerms) != null) rendered.push('netTerms');
    if (fields.requirePaymentMethod != null && (paymentSettings === null || paymentSettings === void 0 ? void 0 : paymentSettings.requirePaymentMethod) != null) {
        rendered.push('requirePaymentMethod');
    }
    const ccFees = paymentSettings === null || paymentSettings === void 0 ? void 0 : paymentSettings.creditCardFeesPaidBy;
    if (fields.creditCardFeesPaidBy != null && ccFees != null && ccFeesHasValues(ccFees)) {
        rendered.push('creditCardFeesPaidBy');
    }
    if (fields.expirationDate != null && (agreementSettings === null || agreementSettings === void 0 ? void 0 : agreementSettings.expirationDate) != null) rendered.push('expirationDate');
    if (fields.amendmentsApprovalMethod != null && (agreementSettings === null || agreementSettings === void 0 ? void 0 : agreementSettings.amendmentsApprovalMethod) != null) {
        rendered.push('amendmentsApprovalMethod');
    }
    if (fields.outOfScopeChargesApprovalMethod != null && (agreementSettings === null || agreementSettings === void 0 ? void 0 : agreementSettings.outOfScopeChargesApprovalMethod) != null) {
        rendered.push('outOfScopeChargesApprovalMethod');
    }
    if (fields.termsOfService != null && (agreementSettings === null || agreementSettings === void 0 ? void 0 : agreementSettings.termsOfService) != null) rendered.push('termsOfService');
    return rendered;
};
